import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_FOOD_MOOD_MUTATION } from '../graphql/mutations'
import { DELETE_FOOD_MOOD } from '../redux/action-types'

const useDeleteFoodMoodMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.foodMoods.foodMoods)

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_FOOD_MOOD_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_FOOD_MOOD,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteFoodMoodMutation
